import React, { PropTypes } from 'react';
import ChapterItem from 'tip/components/ChapterItem';

const NoChapter = () => (
  <div className="ui message">Aucun chapitre. Veuillez en ajouter un.</div>
);

const ChapterList = ({ chapters, ...rest }) => {
  if (chapters.length) {
    return (
      <div>
        {chapters.map(chapter => (
          <ChapterItem key={chapter.id} chapter={chapter} {...rest} />
        ))}
      </div>
    );
  }

  return <NoChapter />;
};

ChapterList.propTypes = {
  chapters: PropTypes.array.isRequired,
};

export default ChapterList;



// WEBPACK FOOTER //
// ./src/modules/tip/components/ChapterList.js